"use client";

import React from "react";
import { MissionType } from "@/types";
import { TriangleAlert } from "lucide-react";
import {
  Badge,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@oreme/ui";
import { useTranslations } from "next-intl";

type MissionListItemProps = {
  mission: MissionType;
  active?: boolean;
  onClick: React.MouseEventHandler;
};

function MissionLisItem({
  mission,
  active = false,
  onClick,
}: Readonly<MissionListItemProps>) {
  const t = useTranslations("mission.MissionLisItem");
  return (
    <button
      className="group rounded hover:cursor-pointer hover:bg-accent data-[state=active]:bg-primary flex flex-row px-2 py-1 items-center justify-between"
      data-state={active ? "active" : "default"}
      onClick={onClick}
    >
      <div className="flex flex-row gap-2 items-center text-sm min-w-0">
        <span className="min-w-[72px] text-foreground group-data-[state=active]:text-primary-foreground">
          {mission.mission_num2}
        </span>
        <em className="leading-tight font-normal text-left not-italic text-sm truncate text-muted-foreground group-data-[state=active]:text-primary-foreground/60">
          {mission.lieu}
        </em>
      </div>
      {mission.sites_nb > 0 ? (
        <Badge variant="secondary">{mission.sites_nb}</Badge>
      ) : (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <TriangleAlert size={20} />
            </TooltipTrigger>
            <TooltipContent>{t("tooltip")}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </button>
  );
}

export { MissionLisItem };
